<div class="app-integration-account-manage">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a
      mat-tab-link
      *ngFor="let tab of tabs; let i = index; trackBy: trackByLabel"
      (click)="activeLink = tab.link"
      [routerLink]="[tab.link]"
      [active]="activeLink === tab.link"
    >
      {{ tab.label }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
